import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefund.SetStatusPayed.IRequest;
type Response = Api.Sales.ContractRefund.SetStatusPayed.IResponse;
type Headers = Api.Sales.ContractRefund.SetStatusPayed.IHeaders;
const url = '/api/Sales/ContractRefund/:id/SetStatusPayed';
export default async function contractRefundSetStatusPayedApi({ id }: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id }, null),
    headers: getDefaultHeaders(),
  });
}
